import {
  Success,
  EmailLogo,
  EmailContent,
  SuccessButton,
} from "../styles/auth";

import { useNavigate, useSearchParams } from "react-router-dom";

const SuccessPage = () => {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const action = params.get("action");

  return (
    <div>
      <Success>
        <EmailContent>
          <EmailLogo src="../../../assets/images/check.png" alt="" />
          <div className="text-medium mt-5 font-medium">
            {action === "email" &&
              "You should soon receive an email allowing you to reset your password. Please make sure to check the spam folder of your mail service if you can't find the email or contact your Admin."}
            {action === "password" && "Password has been successfully updated"}
          </div>
          <SuccessButton onClick={() => navigate("/")}>
            Proceed to login
          </SuccessButton>
        </EmailContent>
      </Success>
    </div>
  );
};

export default SuccessPage;
